import client from '../../../helpers/client';
import cognito from '../../../helpers/cognito';
import {
  GET_LIST_EMAIL_BY_ADDRESS,
  GET_LIST_EMAIL_BY_ADDRESS_SUCCESS,
  GET_LIST_EMAIL_BY_ADDRESS_FAILED,
  SEND_EMAIL_FOR_VOTING,
  SEND_EMAIL_FOR_VOTING_SUCCESS,
  SEND_EMAIL_FOR_VOTING_FAILED
} from '../actionTypes';

export const getListEmailByAddress = (csvFile) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_LIST_EMAIL_BY_ADDRESS });
      
      // Create FormData to handle file upload
      const formData = new FormData();
      formData.append('csvFile', csvFile);
      
      // Call API to upload CSV and get email data by addresses
      const response = await client.api(
        '/email/get-email-by-csv-addresses', 
        'post', 
        formData, 
        {
          headers: {
            ...await cognito.getHeaderAuthorization(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      
      dispatch({
        type: GET_LIST_EMAIL_BY_ADDRESS_SUCCESS,
        payload: response.data
      });
      
      return response.data;
    } catch (err) {
      console.error('Error uploading CSV and getting emails by addresses:', err);
      
      dispatch({
        type: GET_LIST_EMAIL_BY_ADDRESS_FAILED,
        payload: err.response?.data?.message || err.message
      });
      
      throw err;
    }
  };
};

export const sendEmailForVoting = (emailData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SEND_EMAIL_FOR_VOTING });
      
      // Create FormData to handle file upload and additional data
      const formData = new FormData();
      formData.append('csvFile', emailData.csvFile);
      formData.append('startTime', emailData.startTime);
      formData.append('endTime', emailData.endTime);
      formData.append('daoId', emailData.daoId);

      // Call API to send voting emails using CSV file and time parameters
      const response = await client.api(
        '/email/send-voting-emails', 
        'post', 
        formData, 
        {
          headers: {
            ...await cognito.getHeaderAuthorization(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      
      dispatch({
        type: SEND_EMAIL_FOR_VOTING_SUCCESS,
        payload: response.data
      });
      
      return response.data;
    } catch (err) {
      console.error('Error sending voting emails from CSV:', err);
      
      dispatch({
        type: SEND_EMAIL_FOR_VOTING_FAILED,
        payload: err.response?.data?.message || err.message
      });
      
      throw err;
    }
  };
};
